require('./animated-hotspots.scss');

class AnimatedHotspots {
    _devider = 'style://';
    _types = ['two_chevrons'];
    _templates = {};
    _options = {
        wrapperClassName: 'hotspot-animated',
        containerClassName: 'hotspots-mode--animated'
    };

    constructor() {
        this._generateTemplates();
    }

    static mapTemplates(types = []) {
        let templates = {};

        types.forEach((type) => {
            let array = type
                .split('_')
                .map((key, index) => !index ? key : `${key[0].toUpperCase()}${key.slice(1)}`);

            array.unshift('_');
            templates[type] = array.join('');
        });

        return templates;
    }

    _generateTemplates() {
        this._templates = AnimatedHotspots.mapTemplates(this._types);
        Object.keys(this._templates).forEach((key) => {
            this._templates[key] = this[this._templates[key]].bind(this);
        });
    }

    _createWrapper() {
        let {wrapperClassName} = this._options;
        let wrapper = document.createElement('div');

        wrapper.classList.add(wrapperClassName);

        return wrapper;
    }

    /** Templates functions **/

    _twoChevrons() {
        let wrapper = this._createWrapper();
        let {wrapperClassName} = this._options;

        wrapper.classList.add(`${wrapperClassName}--chevrons`);

        for (let i = 0; i < 2; i++) {
            let chevron = document.createElement('div');
            wrapper.appendChild(chevron);
        }

        return wrapper;
    }

    isAnimated(hotspotURL) {
        return !!~this._types.indexOf(hotspotURL.split(this._devider)[1])
    }

    getContainerClass() {
        return this._options.containerClassName;
    }

    getTemplate(hotspotURL) {
        let type = hotspotURL.split(this._devider)[1];

        if (this._templates[type]) return this._templates[type]();

        return null;
    }
}

export default AnimatedHotspots;